import { render, staticRenderFns } from "./df-card-coupon.vue?vue&type=template&id=2070c810&scoped=true"
import script from "./df-card-coupon.ts?vue&type=script&lang=js&external"
export * from "./df-card-coupon.ts?vue&type=script&lang=js&external"
import style0 from "./df-card-coupon.vue?vue&type=style&index=0&id=2070c810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070c810",
  null
  
)

export default component.exports